import { motion } from 'framer-motion';
import { useSession } from '@/session/store';
import { Sparkle } from './icons/Sparkle';

export function ThinkingBubble() {
  const thinkingText = useSession((state) => state.thinkingText);
  const icons = useSession((state) => state.thinkingIcons);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -4 }}
      className="flex items-center gap-3"
    >
      <span className="border-accent/30 bg-accent/10 text-accent-soft grid size-7 shrink-0 place-items-center rounded-full border">
        <motion.span
          animate={{ rotate: 360 }}
          transition={{ duration: 4, ease: 'linear', repeat: Infinity }}
          className="grid place-items-center"
        >
          <Sparkle className="size-3.5" />
        </motion.span>
      </span>

      <span className="text-muted text-sm">{thinkingText}</span>

      <span className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="bg-accent/70 size-1.5 rounded-full"
            animate={{ opacity: [0.25, 1, 0.25] }}
            transition={{ duration: 1.1, repeat: Infinity, delay: i * 0.18 }}
          />
        ))}
      </span>

      {/* The server names an icon per stage. We do not ship its art, so the name itself is the
          signal — which tool is running is exactly what a tester wants to see. */}
      {icons.length > 0 && (
        <span className="text-faint truncate font-mono text-[11px]">{icons.join(' · ')}</span>
      )}
    </motion.div>
  );
}
